import { spacing, styled } from "../../../../stitches.config";
import { FlexColumn } from "../../../Common/__styles__/Layout";

export const WorkflowsPageContainer = styled(FlexColumn, {
  margin: `${spacing.l.value} 0`,
  gap: spacing.l.value,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  "@md": {
    padding: 0,
  },
});
